/** API route map: URLS.Controller.Summary */
export const Summary = {
      Name: 'Summary/',
      GetSummary: 'get-summary',
      GetTaxSummary: 'get-tax-summary',
      CheckEmployeeStatus: 'check-employee-status',
      GetTaxNumber: 'get-employee-ssn',
};
